module.exports = __webpack_public_path__ + "img/10@2x.cfa8baeb.png";